<main>

  <div class="container pt-5">

    <div class="row mb-4">
      <div class="col general-title">
        <h2>Seguros Contratados</h2>
      </div>
    </div>

    <div class="table-responsive">
      <table class="table table-bordered text-center">
        <thead class="thead-light">
          <tr>
            <th>Coberturas</th>
            <th>Capital Segurado(Morte/Invalidez)</th>
            <th>Prêmio</th>
            <th>Status</th>
            <th>Início Vigência</th>
            <th>Fim Vigência</th>
          </tr>
        </thead>
        <tbody>
          @for (item of lista; track item) {
            <tr>
              <td>{{item.DCR_COBERTURA}}</td>
              <td>{{item.VLR_COBERTURA_MORTE| currency:'R$'}} / {{item.VLR_COBERTURA_INVALIDEZ| currency:'R$'}}</td>
              <td>{{(item.VLR_PREMIO_MORTE + item.VLR_PREMIO_INVALIDEZ)| currency:'R$'}}</td>
              <td>{{item.DCR_SEGURO_STATUS}}</td>
              <td>{{item.DTA_INI_VIG| date:"dd/MM/yyyy"}}</td>
              <td>{{(item.DTA_FIM_VIG==null) ? 'Seguro Vigente' : item.DTA_FIM_VIG| date:"dd/MM/yyyy"}}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>

  </div>
</main>